document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.lfm-ofertas');

  sections.forEach((section) => {
    const track = section.querySelector('[data-lfm-track]');
    const slides = Array.from(section.querySelectorAll('[data-lfm-slide]'));
    const prevBtn = section.querySelector('[data-lfm-prev]');
    const nextBtn = section.querySelector('[data-lfm-next]');
    const dotsWrap = section.querySelector('[data-lfm-dots]');

    if (!track || slides.length <= 1) return;

    let currentIndex = 0;
    let autoplayTimer = null;

    const autoplayEnabled = section.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(section.dataset.speed || '5000', 10);

    function renderDots() {
      if (!dotsWrap) return;

      dotsWrap.innerHTML = '';

      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'lfm-ofertas__dot';
        dot.setAttribute('aria-label', `Ir al slide ${index + 1}`);

        if (index === currentIndex) {
          dot.classList.add('is-active');
        }

        dot.addEventListener('click', () => {
          goTo(index);
          restartAutoplay();
        });

        dotsWrap.appendChild(dot);
      });
    }

    function updateSlider() {
      const offset = currentIndex * 100;
      track.style.transform = `translateX(-${offset}%)`;

      const dots = dotsWrap ? dotsWrap.querySelectorAll('.lfm-ofertas__dot') : [];
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === currentIndex);
      });
    }

    function goTo(index) {
      currentIndex = index;
      if (currentIndex < 0) currentIndex = slides.length - 1;
      if (currentIndex >= slides.length) currentIndex = 0;
      updateSlider();
    }

    function next() {
      goTo(currentIndex + 1);
    }

    function prev() {
      goTo(currentIndex - 1);
    }

    function startAutoplay() {
      if (!autoplayEnabled) return;
      stopAutoplay();
      autoplayTimer = setInterval(next, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        next();
        restartAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        prev();
        restartAutoplay();
      });
    }

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    renderDots();
    updateSlider();
    startAutoplay();
  });
});